export default {
      id: "huge-editor-align-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-editor-align-right",
      toString: function () {
        return this.url;
      }
    }